import { Archive, LinkSimple, ListChecks } from "@phosphor-icons/react";
import { OpexInvoiceCounts, OpexViewMode } from "../hooks/useOpexInvoices";

interface Props {
  viewMode: OpexViewMode;
  counts: OpexInvoiceCounts | null;
  onChange: (viewMode: OpexViewMode) => void;
}

const TABS: Array<{
  key: OpexViewMode;
  label: string;
  icon: typeof ListChecks;
  countKey: keyof OpexInvoiceCounts;
}> = [
  { key: "unlinked", label: "Nog te koppelen", icon: ListChecks, countKey: "unlinked" },
  { key: "linked", label: "Gekoppeld", icon: LinkSimple, countKey: "linked" },
  { key: "archived", label: "Gearchiveerd", icon: Archive, countKey: "archived" },
];

/**
 * Weergaven van de OPEX-werkvoorraad.
 *
 * "Nog te koppelen" laat gekoppelde én gearchiveerde regels weg, zodat die teller
 * een echte werkvoorraad is die op nul kan.
 */
export const OpexViewTabs = ({ viewMode, counts, onChange }: Props) => (
  <div
    role="tablist"
    aria-label="Weergave factuurregels"
    className="border-neutral-primary/10 flex items-center gap-1 border-b"
  >
    {TABS.map((tab) => {
      const isActive = viewMode === tab.key;
      const count = counts?.[tab.countKey];
      const Icon = tab.icon;

      return (
        <button
          key={tab.key}
          role="tab"
          type="button"
          aria-selected={isActive}
          onClick={() => onChange(tab.key)}
          className={`-mb-px inline-flex items-center gap-2 border-b-2 px-4 py-2.5 text-sm transition-colors ${
            isActive
              ? "border-moss-primary text-neutral-primary font-semibold"
              : "text-neutral-secondary-mid hover:text-neutral-primary border-transparent"
          }`}
        >
          <Icon size={16} weight={isActive ? "fill" : "regular"} />
          {tab.label}
          {count !== undefined && (
            <span
              className={`rounded-full px-2 py-0.5 text-xs tabular-nums ${
                isActive
                  ? "bg-moss-secondary-light text-neutral-primary"
                  : "bg-neutral-secondary-light text-neutral-secondary-mid"
              }`}
            >
              {count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);
